define('plugin/paid-attributes/view/AttributeItemView',['require','plugin/product/view/ProductItemView','lib/theme/ThemeSettings'],function (require) {

    var ProductItemView = require('plugin/product/view/ProductItemView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Attribute item view
     *
     * @class AttributeItemView
     */
    return ProductItemView.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#paid_attribute_item_view_list';
            }
            return '#paid_attribute_item_view';
        }

    });

});
